import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { ApiClient } from '../api'
import type { LibraryComponentCreate, LibraryComponentPatch } from '../types'

// Org-level Library Components catalog (mig 034 / PR A). Long stale
// time — the catalog changes infrequently and the per-event pickers
// need it available without a round-trip on every render. Manual
// invalidation on every mutation keeps things fresh.

export function useLibraryComponents() {
  return useQuery({
    queryKey: ['library-components'],
    queryFn: ApiClient.libraryComponents,
    staleTime: 30 * 60_000
  })
}

export function useCreateLibraryComponent() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: LibraryComponentCreate) => ApiClient.createLibraryComponent(body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['library-components'] })
  })
}

export function usePatchLibraryComponent() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: LibraryComponentPatch }) =>
      ApiClient.patchLibraryComponent(id, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['library-components'] })
  })
}

export function useDeleteLibraryComponent() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => ApiClient.deleteLibraryComponent(id).then(() => id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['library-components'] })
  })
}
